"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Tue Oct 16 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowConverter.
 *
 * @author JMt
 */


var WindowConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowConverter, _DataObjectConverter_);

  function WindowConverter() {
    _classCallCheck(this, WindowConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowConverter).apply(this, arguments));
  }

  return WindowConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowConverter = WindowConverter;